export default {
  MNDE: {
    minimumWidrawalAmount: 10.0,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
  MPLX: {
    minimumWidrawalAmount: 5.0,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
  SWTCH: {
    minimumWidrawalAmount: 10.0,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
  SOL: {
    minimumWidrawalAmount: 0.01,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
  DRVS: {
    minimumWidrawalAmount: undefined,
    allowsWithdrawals: false,
    currencyDescription: "Token Generation Event in 2025",
  },
  USDC: {
    minimumWidrawalAmount: 1.0,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
  ZRC: {
    minimumWidrawalAmount: 100,
    allowsWithdrawals: true,
    currencyDescription: undefined,
  },
};
